import { Stack } from 'expo-router';
import type { DimensionValue, FlexAlignType, ViewStyle } from 'react-native';
import { View } from 'smoothie';

import { FruitSliceSidebarRail } from '../../fruit-slices/components/FruitSliceSidebarRail';
import { APP_SHELL_WIDTH } from '../utils/layout';
import { BaseHeaderProps, HeaderActions } from './AppHeader';
import { QuickSearchModal } from './QuickSearchModal';

const BaseScreenOptions = {
    contentStyle: {
        width: '100%' as DimensionValue,
        height: '100%' as DimensionValue,
        minWidth: '100%' as DimensionValue,
        minHeight: '80vh' as DimensionValue,
        marginHorizontal: 'auto' as DimensionValue,
        marginVertical: 'auto' as DimensionValue,
        display: 'flex' as const,
        flexDirection: 'column' as const,
        alignItems: 'center' as FlexAlignType,
        alignSelf: 'center' as FlexAlignType,
        overflow: 'auto' as ViewStyle['overflow'],
    },
};

export const AppStack = () => {
    return (
        <>
            {/* Before the navigator on purpose. Modals rendered with
                `renderInAppRoot={false}` sit inside the page's stacking
                context, so no z-index on the rail can be under them and above
                the page at the same time. Painting the whole app after the rail
                lets every modal cover it, portalled or not. */}
            <FruitSliceSidebarRail />
            <View flex={1} width={APP_SHELL_WIDTH} height="100%">
                <Stack
                    screenOptions={{
                        ...BaseScreenOptions,
                        ...BaseHeaderProps,
                        headerRight: () => {
                            return <HeaderActions />;
                        },
                    }}
                />
            </View>
            <QuickSearchModal />
        </>
    );
};
